export default {
  catalogue_image: 'Catalogue images',
  catalogues_in_area: 'Catalogues',
  catalogues_loading: 'Loading',
  catalogues_near_you: 'Catalogues in your area',
  close_catalogues: 'Close',
  other_stores: 'Offers available here:',
  stores_within: 'Stores within {maxDistance}',
  invalid_offers_disclaimer: 'The offers of this flyer are not valid in stores near you, open another flyer or located in a different area.',
}
